// removed by extract-text-webpack-plugin
module.exports = {"container":"_37-ztpzNjsARgPfLkMel_Y"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Loading/styles.css
// module id = 1288
// module chunks = 83